export default __webpack_public_path__ + "static/media/sponsor-stockcar.f9a461ff.png";